module.exports = __webpack_public_path__ + "img/xAxis.eaa46181.svg";